import React from 'react';
import axios, { AxiosResponse } from 'axios';
import styled from '@emotion/styled';
import ModalBase from '../../../../common/modal/ModalBase';
import Span from '../../../../common/text/Span';
import Title from '../../../../common/text/Title';
import SimpleButton from '../../../../common/button/SimpleButton';
import { LIGHT_BLUE, WHITE } from '../../../../../styles/constants/color';
import useActiveTab from '../../../../../hooks/estimate/common/useActiveTab';
import useSaveForNewcar from '../../../../../hooks/estimate/common/save/useSaveForNewcar';

const Base = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-items: center;
  align-items: center;

  & > h1,
  & > span {
    grid-column: span 2;
  }

  & > button {
    width: 75px;
    margin-top: 20px;
  }
`;

interface Props {
  closeEvent: () => void;
}

/**
 *  일시불 캐시백 신청 확인 모달 컴포넌트
 * @param {function} closeEvent 닫기 함수
 *  */
function CashbackConfirmModal({ closeEvent }: Props): JSX.Element {
  // tab
  const { id } = useActiveTab();
  // hook
  const { getEstimateTitle, getSimple, getDetail } = useSaveForNewcar();

  const onClick = () => {
    (async () => {
      const returnArray = [];
      for (let i = 0; i < 3; i++) {
        const index: number = i + 1;

        const isActive: boolean = index === id;
        const estimateTitle: string = getEstimateTitle(index);
        const simple = getSimple(index);
        const detail = getDetail(index);

        returnArray.push({
          estimateTitle,
          simple,
          detail,
          isActive,
        });
      }

      const formData: FormData = new FormData();
      const config = {
        async: true,
        crossDomain: true,
        headers: {
          'Content-Type': 'multipart/form-data',
          'cache-control': 'no-cache',
        },
        processData: false,
        contentType: false,
        mimeType: 'multipart/form-data',
      };
      formData.append('data', JSON.stringify(returnArray));

      const response: AxiosResponse<any, any> = await axios.post(
        '/newcar/api/set/estimate',
        formData,
        config
      );

      const estimateNo: number = response?.data || 0;
      const { protocol, host } = window.location;

      // 오리지널 URL
      const originUrl: string = '/estimate/sharing'.replace(/&/g, '%26').replace(/\+/g, '%2B');
      // 요청 URL
      const reqUrl: string =
        // `/new/car/estimate/url/make?originUrl=${originUrl}?simpleEstimateNo=${estimateNo}&ag=true&protocol=${protocol}//${host}/estimate/sharing/`.replace(
        `/new/car/estimate/url/make?originUrl=${originUrl}?simpleEstimateNo=${estimateNo}&protocol=${protocol}//${host}/estimate/sharing/`.replace(
          / /gi,
          ''
        );
      await axios.get(reqUrl);
      await axios
        .post(`/newcar/api/applyForLumpSumCashback?newEstimateNo=${estimateNo}`)
        .then(() => {
          alert('일시불 캐시백 신청이 완료되었습니다.');
          closeEvent();
        })
        .catch(err => {
          alert('신청이 실패하였습니다. 관리자에게 문의해주세요.');
          console.log('일시불캐시백 신청 에러 => ', err);
        });
    })();
  };
  return (
    <ModalBase active={true} closeEvent={closeEvent}>
      <Base>
        <Title text='일시불 캐시백 신청' />
        <Span fontSize='15px'>일시불 캐시백을 신청하시겠습니까?</Span>
        <SimpleButton
          text='신청'
          backgroundColor={LIGHT_BLUE}
          color={WHITE}
          borderColor={LIGHT_BLUE}
          onClick={onClick}
        />
        <SimpleButton text='취소' onClick={closeEvent} />
      </Base>
    </ModalBase>
  );
}

export default CashbackConfirmModal;
